import type { HelpFile } from '../../types/help'
import { ExpressionEditorTestIds } from '../../../testids/ExpressionEditorTestIds'

export const expressionEditorHelp: HelpFile = {
  docPage: '/docs/reference/cel',
  texts: {
    [ExpressionEditorTestIds.expressionEditorTextarea]: 'CEL-Ausdruck eingeben — Autovervollständigung verwenden, um Attributreferenzen und Operatoren einzufügen.',
  },
}
